import {DateTime} from "@2d-front-monorepo/core";
import {HolderId} from "../nominalTypes/HolderId";
import {InstallationId} from "../nominalTypes/InstallationId";
import {PermitId} from "../nominalTypes/PermitId";
import {ReservationId} from "../nominalTypes/ReservationId";
import {TariffId} from "../nominalTypes/TariffId";
import {VehicleId} from "../nominalTypes/VehicleId";
import {ZoneId} from "../nominalTypes/ZoneId";
import {ReservationQuotationResult} from "./arguments/ReservationQuotationResult";
import {BillingData} from "./BillingData.js";
import {IntegraParkingOperation} from "./IntegraParkingOperation.js";

interface PaymentHistoryEntry {
	id: number;
	installationId: InstallationId;
	holderId: HolderId;
	type: PaymentHistoryEntryType;
	tariffId: TariffId;
	startDate: DateTime;
	endDate?: DateTime;

	zoneId?: ZoneId;
	permitId?: PermitId;
	operation?: IntegraParkingOperation;
	billingData?: BillingData;
	vehicleIds?: VehicleId[];

	reservationId?: ReservationId;
	quotation?: ReservationQuotationResult;
}

enum PaymentHistoryEntryType {
	Undefined,
	Permit,
	Reservation
}


export {PaymentHistoryEntry, PaymentHistoryEntryType};
